import { useFirestoreConnect } from 'react-redux-firebase'

import { Grid, LinearProgress } from '@material-ui/core'

import { useOrganization, useNotification, useOrgFeatureFlags } from 'hooks'

import { OrganizationForm } from './OrganizationForm'
import { CompanyStatistic } from './CompanyStatistic'
import { UpcomingPlanNotification } from './UpcomingPlanNotification'

import { logToAnalytics, updateOrganization } from 'modules'
import { ExceededUsersNotification } from '../ExceededUsersNotification'

type Props = {
    orgId: string
    usersExceeded: boolean
}

export const AccountTab = ({ orgId, usersExceeded }: Props) => {
    const { showSuccessNotification } = useNotification()

    const { showPayments, showUsage } = useOrgFeatureFlags()

    useFirestoreConnect({
        collection: 'organizations',
        doc: orgId
    })

    const {
        name,
        domains,
        useDefaultCoverColors,
        isLoading,
        defaultSpaces = [],
        defaultSharingSettings,
        comments
    } = useOrganization(orgId)

    if (isLoading) {
        return <LinearProgress />
    }

    return (
        <Grid container>
            <Grid item sm={6} md={4}>
                <OrganizationForm
                    initialValues={{
                        name,
                        domains,
                        defaultSpaces,
                        useDefaultCoverColors,
                        defaultSharingSettings,
                        id: orgId,
                        comments
                    }}
                    onSubmit={values => {
                        updateOrganization(values).then(() => {
                            showSuccessNotification('Organization has been updated')
                            logToAnalytics('change_settings')
                        })
                    }}
                />
            </Grid>
            <Grid item sm={7} md={3} />

            {showUsage && (
                <Grid item sm={7} md={5}>
                    {showPayments && (
                        <>
                            <UpcomingPlanNotification />
                            {usersExceeded && <ExceededUsersNotification />}
                        </>
                    )}
                    <CompanyStatistic />
                </Grid>
            )}
        </Grid>
    )
}
